export async function getHls(searchParams, getAccessToken) {
  const accessToken = getAccessToken ? await getAccessToken() : undefined;
  return import('hls.js').then((module) => {
    const Hls = module.default;
    if (Hls.isSupported()) {
      return new Hls({
        startFragPrefetch: true,
        fLoader: class CustomLoader extends Hls.DefaultConfig.loader {
          load(context, config, callbacks) {
            context.url = context.url + searchParams;
            super.load(context, config, callbacks);
          }
        },
        xhrSetup: function (xhr) {
          accessToken &&
            xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
        },
      });
    }
  });
}
